export function PrivacyPolicy() {
  return `
    <section class="privacy-policy">
      <div class="container">
        <div class="privacy-policy__content">
          <h1 class="text-xl">Privacy e Cookie Policy</h1>

          <div class="privacy-policy__section">
            <h2 class="text-md">Informativa privacy ai sensi degli artt. 13-14 del Regolamento Europeo “Privacy” (GDPR)</h2>
            <p class="text-base">In questa informativa la società Forma Studio S.r.l.s. con P.iva 08888740720 e sede in Via Gioia del Colle, 40 - 70017 Putignano (BA) titolare del trattamento dei dati raccolti tramite www.formastudiotraining.it le dà atto di quelle che sono le proprie politiche di trattamento dei dati personali che raccoglie in fase di navigazione sul sito www.formastudiotraining.it</p>
          </div>

          <div class="privacy-policy__section">
            <h2 class="text-md">1. Tipologie di dati trattati e finalità</h2>
            <p class="text-base">Visitando questo sito web, <b>non vengono raccolti dati personali degli utenti</b>. Non vengono utilizzati moduli di contatto, form di iscrizione né strumenti di raccolta automatica di dati personali.</p>
          </div>

          <div class="privacy-policy__section">
            <h2 class="text-md">2. Cookie</h2>
            <p class="text-base">Questo sito utilizza <b>esclusivamente cookie tecnici</b>, necessari per il corretto funzionamento del sito stesso. <b>Non vengono utilizzati cookie di profilazione o di analisi.</b></p>
            <p class="text-base">Il sito contiene un <b>collegamento al servizio esterno Google Calendar</b>, utilizzato per prenotare consulenze.<br/>
            Accedendo a Google Calendar, l’utente viene reindirizzato a una piattaforma gestita da Google LLC, che potrebbe trattare dati personali secondo le proprie modalità.
            Per maggiori informazioni, consultare la privacy policy di Google: <a href="https://policies.google.com/privacy" target="_blank">https://policies.google.com/privacy</a></p>
          </div>

          <div class="privacy-policy__section">
            <h2 class="text-md">3. Base giuridica del trattamento</h2>
            <p class="text-base">Il sito non effettua alcun trattamento di dati personali.</p>
          </div>

          <div class="privacy-policy__section">
            <h2 class="text-md">4. Modifiche alla privacy policy</h2>
            <p class="text-base">Ci riserviamo il diritto di aggiornare questa Privacy e Cookie policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con una data di revisione aggiornata.<br/> Si consiglia di verificarne periodicamente il contenuto.</p>
          </div>

          <div class="privacy-policy__section">
            <h2 class="text-md">5. Contatti</h2>
            <p class="text-base">Per qualsiasi domanda riguardo questa Privacy e Cookie policy o il trattamento dei tuoi dati personali, puoi contattarci tramite email all'indirizzo <a href="mailto:info@formastudiotraining.it">info@formastudiotraining.it</a></p>
          </div>

          <div class="privacy-policy__section">
            <p class="text-base"><strong>Ultimo aggiornamento:</strong> 08/07/2025</p>
          </div>
        </div>
      </div>
    </section>
  `;
} 